const data = {
  title: "Floor 5-3",
  musicTrack: "MUSIC_WORLD1",
  theme: "YELLOW",
  tilesWidth: 18,
  tilesHeight: 7,
  placements: [
    {
      type: "HERO_SPAWN",
      x: 3,
      y: 1,
    },
    {
      type: "PLACEMENT_TYPE_GOAL",
      x: 14,
      y: 1,
    },
    {
      type: "ENEMY_SPAWN",
      x: 5,
      y: 2,
      direction: "DOWN",
      enemyType: "ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 6,
      y: 4,
      direction: "DOWN",
      enemyType: "ENEMY",
    },
    {
      type: "CHIP",
      x: 4,
      y: 7,
    },
    {
      type: "CHIP",
      x: 5,
      y: 3,
    },
    {
      type: "CHIP",
      x: 6,
      y: 1,
    },
    {
      type: "CHIP",
      x: 1,
      y: 1,
    },
    {
      type: "FIRE",
      x: 1,
      y: 3,
    },
    {
      type: "FIRE",
      x: 2,
      y: 3,
    },
    {
      type: "FIRE",
      x: 2,
      y: 2,
    },
    {
      type: "FIRE",
      x: 2,
      y: 1,
    },
    {
      type: "TELEPORT",
      x: 1,
      y: 2,
    },
    {
      type: "WALL",
      x: 11,
      y: 2,
    },
    {
      type: "WALL",
      x: 13,
      y: 1,
    },
    {
      type: "WALL",
      x: 13,
      y: 2,
    },
    {
      type: "SWITCH",
      x: 12,
      y: 2,
    },
    {
      type: "WALL",
      x: 11,
      y: 6,
    },
    {
      type: "WALL",
      x: 12,
      y: 6,
    },
    {
      type: "WALL",
      x: 13,
      y: 6,
    },
    {
      type: "ENEMY_SPAWN",
      x: 11,
      y: 7,
      enemyType: "ROAMING_ENEMY",
    },
    {
      type: "ENEMY_SPAWN",
      x: 12,
      y: 7,
      enemyType: "ROAMING_ENEMY",
    },
    {
      type: "WALL",
      x: 13,
      y: 7,
    },
    {
      type: "ICE",
      x: 6,
      y: 7,
    },
    {
      type: "ICE",
      x: 8,
      y: 7,
    },
    {
      type: "ICE",
      x: 7,
      y: 7,
    },
    {
      type: "ICE",
      x: 7,
      y: 6,
    },
    {
      type: "ICE",
      x: 7,
      y: 5,
    },
    {
      type: "ICE",
      x: 9,
      y: 7,
    },
    {
      type: "SWITCH_WALL",
      x: 10,
      y: 7,
      isRaised: true,
    },
    {
      type: "CHIP",
      x: 14,
      y: 7,
    },
    {
      type: "KEY",
      x: 2,
      y: 6,
      color: "BLUE",
    },
    {
      type: "WATER_PICKUP",
      x: 2,
      y: 5,
    },
    {
      type: "WATER",
      x: 3,
      y: 5,
    },
    {
      type: "WATER",
      x: 2,
      y: 4,
    },
    {
      type: "WATER",
      x: 1,
      y: 4,
    },
    {
      type: "WATER",
      x: 1,
      y: 5,
    },
    {
      type: "WATER",
      x: 1,
      y: 6,
    },
    {
      type: "WATER",
      x: 1,
      y: 7,
    },
    {
      type: "WATER",
      x: 2,
      y: 7,
    },
    {
      type: "WATER",
      x: 3,
      y: 7,
    },
    {
      type: "WATER",
      x: 4,
      y: 7,
    },
    {
      type: "WALL",
      x: 5,
      y: 7,
    },
    {
      type: "WATER",
      x: 4,
      y: 5,
    },
    {
      type: "WATER",
      x: 3,
      y: 4,
    },
    {
      type: "WATER",
      x: 5,
      y: 5,
    },
    {
      type: "WALL",
      x: 11,
      y: 3,
    },
    {
      type: "WALL",
      x: 13,
      y: 3,
    },
    {
      type: "WALL",
      x: 10,
      y: 2,
    },
    {
      type: "CONVEYOR",
      x: 11,
      y: 1,
      direction: "LEFT",
    },
    {
      type: "CONVEYOR",
      x: 12,
      y: 3,
      direction: "UP",
    },
    {
      type: "CONVEYOR",
      x: 12,
      y: 1,
      direction: "LEFT",
    },
    {
      type: "TELEPORT",
      x: 13,
      y: 5,
    },
    {
      type: "WALL",
      x: 15,
      y: 1,
    },
    {
      type: "WALL",
      x: 16,
      y: 2,
    },
    {
      type: "SWITCH_WALL",
      x: 17,
      y: 1,
      isRaised: false,
    },
    {
      type: "CHIP",
      x: 16,
      y: 1,
    },
    {
      type: "WALL",
      x: 15,
      y: 7,
    },
    {
      type: "WALL",
      x: 15,
      y: 6,
    },
    {
      type: "WATER",
      x: 18,
      y: 2,
    },
    {
      type: "WATER",
      x: 17,
      y: 4,
    },
    {
      type: "WALL",
      x: 18,
      y: 7,
    },
    {
      type: "ENEMY_SPAWN",
      x: 4,
      y: 1,
      direction: "DOWN",
      enemyType: "FLYING_ENEMY",
    },
    {
      type: "CHIP",
      x: 11,
      y: 1,
    },
    {
      type: "CONVEYOR",
      x: 10,
      y: 1,
      direction: "LEFT",
    },
    {
      type: "SWITCH_WALL",
      x: 9,
      y: 2,
      isRaised: false,
    },
    {
      type: "SWITCH_WALL",
      x: 8,
      y: 2,
      isRaised: false,
    },
    {
      type: "SWITCH_WALL",
      x: 7,
      y: 2,
      isRaised: false,
    },
    {
      type: "LOCK",
      x: 14,
      y: 5,
      color: "BLUE",
    },
    {
      type: "THIEF",
      x: 14,
      y: 6,
    },
    {
      type: "FIRE_BOOTS",
      x: 16,
      y: 7,
    },
    {
      type: "ICE_BOOTS",
      x: 17,
      y: 7,
    },
    {
      type: "ENEMY_SPAWN",
      x: 18,
      y: 3,
      direction: "LEFT",
      enemyType: "ENEMY",
    },
  ],
};

export default data;
